import { render, staticRenderFns } from "./Vacinador.vue?vue&type=template&id=46f1695b&"
import script from "./Vacinador.vue?vue&type=script&lang=js&"
export * from "./Vacinador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports